import { Button } from '@material-ui/core'
import React, { useState } from 'react'
import login1 from '../../../../assets/images/login.svg'
import firebase_ from '../../../../firebase/firebase'
import './Login.css'
import firebase from 'firebase'
import SignUp from '../signup/SignUp'
import AdminLogin from '../adminLogin/AdminLogin'
export default function Login() {

    // state variables declaration
    const [userName, setUserName] = useState('')
    const [password, setPassword] = useState('')
    const [loggedIn, setLoggedIn] = useState(false)
    const [admin, setAdmin] = useState(false)
    const [signUpFlag, setSignUpFlag] = useState(false)
    const [signUpUserName, setSignUpUserName] = useState('')
    const [signUpPassword, setSignUpPassword] = useState('')
    const [signUpConfirmPassword, setSignUpConfirmPassword] = useState('')
    const [signUpEmailId, setSignUpEmailId] = useState('')

    const db = firebase_.firestore()

    // methods

    const onChangeSignUp = (e) => {
        if (e.target.name === "signUpUserName") {
            setSignUpUserName(e.target.value)
        } else if (e.target.name === "signUpPassword") {
            setSignUpPassword(e.target.value)
        } else if (e.target.name === "signUpConfirmPassword") {
            setSignUpConfirmPassword(e.target.value)
        } else if (e.target.name === "signUpEmailId") {
            setSignUpEmailId(e.target.value)
        }
    }

    const registerUser = (e) => {
        e.preventDefault()
        firebase.auth().createUserWithEmailAndPassword(signUpEmailId, signUpPassword)
            .then((userCredential) => {
                // Signed in 
                userCredential.user.updateProfile({
                    displayName : signUpUserName

                })
                var user = userCredential.user;
                db.collection('Users').where("uid", "==", user.uid).get()
                    .then(res => {
                        if (res.size > 0) {
                            alert('User already exists')
                            sessionStorage.setItem('userName', user.displayName)
                            sessionStorage.setItem('emailId', user.email)
                            sessionStorage.setItem('imgUrl', user.photoURL)
                            sessionStorage.setItem('loggedIn', true)
                            sessionStorage.setItem('loggedInUser', 'user')
                            window.location.reload()
                        }
                        else {
                            db.collection('Users').add({
                                "userName": signUpUserName,
                                "emailId": signUpEmailId,
                                "profileImageUrl": '',
                                "uid": user.uid
                            }).then(response => {
                                
                                console.log('added successfully', response);
                                sessionStorage.setItem('userName', signUpUserName)
                                sessionStorage.setItem('emailId', signUpEmailId)
                                sessionStorage.setItem('imgUrl', '')
                                sessionStorage.setItem('loggedIn', true)
                                sessionStorage.setItem('loggedInUser', 'user')
                                window.location.reload()

                            }).catch(err => {
                                console.log('error in users', err);
                                sessionStorage.setItem('userName', signUpUserName)
                                sessionStorage.setItem('emailId', signUpEmailId)
                                sessionStorage.setItem('imgUrl', '')
                                sessionStorage.setItem('loggedIn', true)
                                sessionStorage.setItem('loggedInUser', 'user')
                                window.location.reload()
                            })

                           
                        }

                    }).catch(err => {
                        console.log('error in auth verification', err);
                    })

            })
            .catch((error) => {
                var errorCode = error.code;
                var errorMessage = error.message;
                console.log(error);
                // ..
            });
    }

    const onChange = (e) => {
        if (e.target.name === "userName") {
            setUserName(e.target.value)
        } else if (e.target.name === "password") {
            setPassword(e.target.value)
        }

    }

    const submitForm = (e) => {
        e.preventDefault();
        firebase.auth().signInWithEmailAndPassword(userName, password)
            .then((userCredential) => {
                // Signed in
                var user = userCredential.user;
                sessionStorage.setItem('userName', user.displayName)
                sessionStorage.setItem('emailId', user.email)
                sessionStorage.setItem('imgUrl', user.photoURL)
                sessionStorage.setItem('loggedIn', true)
                sessionStorage.setItem('loggedInUser', 'user')
                window.location.reload()
            })
            .catch((error) => {
                var errorCode = error.code;
                var errorMessage = error.message;
                console.log('error in login', error);
            });
        /*
     if (userName === "digvi" && password === "Digvi123") {
        sessionStorage.setItem('userName', 'digvijay')
        sessionStorage.setItem('emailId', 'digvijay@gmail.com')
        sessionStorage.setItem('imgUrl', '')
        sessionStorage.setItem('loggedIn', true)
        sessionStorage.setItem('loggedInUser', 'user')

        window.location.reload()
    }
    */
    }
    const handleGoogleLogin = (e) => {
        e.preventDefault()
        console.log('google login');
        var provider = new firebase.auth.GoogleAuthProvider();
        firebase_.auth().signInWithPopup(new firebase.auth.GoogleAuthProvider())
            .then(result => {
                var user = result.user;


                db.collection('Users').where("uid", "==", user.uid).get()
                    .then(res => {
                        if (res.size > 0) {
                            alert('User already exists')
                            sessionStorage.setItem('userName', user.displayName)
                            sessionStorage.setItem('emailId', user.email)
                            sessionStorage.setItem('imgUrl', user.photoURL)
                            sessionStorage.setItem('loggedIn', true)
                            sessionStorage.setItem('loggedInUser', 'user')

                            window.location.reload()
                        }
                        else {
                            db.collection('Users').add({
                                "userName": user.displayName,
                                "emailId": user.email,
                                "profileImageUrl": user.photoURL,
                                "uid": user.uid
                            }).then(res => {
                                console.log('added successfully', res);
                                sessionStorage.setItem('userName', user.displayName)
                                sessionStorage.setItem('emailId', user.email)
                                sessionStorage.setItem('imgUrl', user.photoURL)
                                sessionStorage.setItem('loggedIn', true)
                                sessionStorage.setItem('loggedInUser', 'user')
                                window.location.reload()
                            }).catch(err => {
                                console.log('error in users', err);
                            })
                        }

                    }).catch(err => {
                        console.log('error in auth verification', err);
                    })

                console.log(user.uid);


            })
            .catch((error) => {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                // The email of the user's account used.
                var email = error.email;
                // The firebase.auth.AuthCredential type that was used.
                var credential = error.credential;
                // ...
            });





    }
    const handleAdmin = (e) => {
        e.preventDefault()
        setAdmin(true)

    }

    const handleSignUp = (e) => {
        e.preventDefault()
        setSignUpFlag(!signUpFlag)
    }


    if (admin) {
        return (
            <div>
                <AdminLogin />
            </div>
        )

    }

    return (
        <div>

            <Button onClick={handleAdmin}>Admin</Button>
            <div className="Login-Page">

                <div className="Login_Page_Container">
                    <div className="Image_Container">
                        <img src={login1} alt="illustrations" className="login-img" />
                    </div>
                    {signUpFlag ?
                        <div>
                            <div className="Form_Wrapper">
                                <p id="Heading">SignUp</p>
                                <form className="Input_Field_container" onSubmit={registerUser}>

                                    <i class="fa fa-user"></i>
                                    <input
                                        className="add-question-inpt"
                                        type="text"
                                        placeholder="Email Id"
                                        name="signUpEmailId"
                                        title="Password must be 8 Characters"
                                        value={signUpEmailId}
                                        onChange={onChangeSignUp}
                                    />
                                    <input
                                        className="add-question-inpt"
                                        type="text"
                                        placeholder="Full Name"
                                        name="signUpUserName"
                                        title=""
                                        value={signUpUserName}
                                        onChange={onChangeSignUp}
                                    />



                                    <i class="fa fa-lock"></i>
                                    <input
                                        className="add-question-inpt"
                                        type="password"
                                        placeholder="Password"
                                        name="signUpPassword"
                                        value={signUpPassword}
                                        onChange={onChangeSignUp}
                                    />
                                    <i class="fa fa-lock"></i>
                                    <input
                                        className="add-question-inpt"
                                        type="password"
                                        placeholder="Confirm Password"
                                        name="signUpConfirmPassword"
                                        value={signUpConfirmPassword}
                                        onChange={onChangeSignUp}
                                    />

                                    <Button type="submit" variant="contained" className="login-btn">SignUp</Button>
                                    <img style={{ marginLeft: '46%' }} onClick={handleGoogleLogin} src="https://img.icons8.com/fluent/48/000000/google-logo.png" />
                                    <p style={{ textAlign: 'center', color: 'blue', cursor: 'pointer' }} onClick={() => { setSignUpFlag(!signUpFlag) }}>Have account ? Login</p>
                                </form>
                            </div>
                        </div> :
                        <div>
                            <div className="Form_Wrapper">
                                <p id="Heading">Login</p>
                                <form className="Input_Field_container" onSubmit={submitForm}>

                                    <i class="fa fa-user"></i>
                                    <input
                                        className="add-question-inpt"
                                        type="text"
                                        placeholder="Username"
                                        name="userName"
                                        title="Password must be 8 Characters"
                                        value={userName}
                                        onChange={onChange}
                                    />



                                    <i class="fa fa-lock"></i>
                                    <input
                                        className="add-question-inpt"
                                        type="password"
                                        placeholder="Password"
                                        name="password"
                                        value={password}
                                        onChange={onChange}
                                    />

                                    <Button type="submit" variant="contained" className="login-btn">Login</Button>
                                    <img style={{ marginLeft: '46%' }} onClick={handleGoogleLogin} src="https://img.icons8.com/fluent/48/000000/google-logo.png" />
                                    <p style={{ textAlign: 'center', color: 'blue', cursor: 'pointer' }} onClick={handleSignUp}>New User ? SignUp</p>
                                </form>
                            </div>
                        </div>
                    }

                </div>
            </div>
        </div>
    )
}